module.exports = __webpack_public_path__ + "img/carture.88aeccc3.png";